import React from 'react';
import { routeHistory } from '@nackle/biw-web-router';
import { FileTable, setFileParameters } from '../../../loader-hatch/index';
import auth from '../../app-auth';
import { Button, Modal, Input } from 'antd';

export default class ListPage extends React.Component {
    state = {
        modalVisible: false,
        parentBudgetId: '',
    };

    render() {
        const {
            modalVisible,
            parentBudgetId
        } = this.state;

        const {
            route: {
                params: {
                    fileType = ''
                } = {}
            } = {}
        } = this.props;

        return (
            <div className="page list-page">
                <div className="page-header">
                    <h1>Files</h1>
                    <Button
                        disabled={ !fileType }
                        onClick={ () => {
                            this.setState( {
                                modalVisible: true
                            } );
                        } }
                    >
                        <span>Load File</span>
                    </Button>
                </div>
                <div label="File Type">
                    <select
                        value={ fileType }
                        onChange={ ( e ) => routeHistory.replace( `/${ e.target.value }` ) }
                    >
                        <option value=""></option>
                    </select>
                </div>
                {
                    fileType && (
                        <FileTable
                            auth={ auth }
                            onFileClick={ ( fileId ) => routeHistory.push( `/files/${ fileId }` ) }
                        />
                    )
                }
                <Modal
                    title="Budget Info"
                    visible={ modalVisible }
                    onOk={ () => {
                        this.setState( {
                            modalVisible: false
                        }, () => {
                            setFileParameters( {
                                parentBudgetId
                            } );
                            routeHistory.push( `/${ fileType }/load` );
                        } );
                    } }
                    onCancel={ () => {
                        this.setState( {
                            modalVisible: false
                        } );
                    } }
                >
                    <Input
                        value={ parentBudgetId }
                        onChange={ e => {
                            this.setState( {
                                parentBudgetId: e.target.value
                            } );
                        } }
                    />
              </Modal>
            </div>
        );
    }
}
